const findTruncateLength = (isMobile, sliderHeight, isAdditionalDataAvailable) => {
	const additionalDataButtonHeight = isAdditionalDataAvailable ? 50 : 0;
	const otherElementHeight = isMobile ? 470 + additionalDataButtonHeight : 500 + additionalDataButtonHeight;
	// const noOfCharsPerRow = isMobile ? 30 : 50;

	const noOfRowsOfText = Math.floor((sliderHeight - otherElementHeight) / 20);
	return noOfRowsOfText;
	// const truncateLength = noOfRowsOfText * noOfCharsPerRow - 25; // the 25 is to accomodate readmore
	// return truncateLength;
};

export default findTruncateLength;
